import { CLIENT_API_URL, fmhNpiAPI } from 'api/APIBase';

export interface HealthPlanNotesAttestation {
    referral_id?: string;
    username?: string;
    attestation_date?: string;
}

export async function getHealthPlanNotesAttestationForReferral({
    npi,
    referralId,
    payerId,
}: {
    npi: string;
    referralId: string;
    payerId: string;
}) {
    const url = `${CLIENT_API_URL}/${payerId}/attestations/${referralId}`;
    return fmhNpiAPI({ url, npi })
        .get()
        .notFound(() => ({})) // No attestation, return empty object
        .json<HealthPlanNotesAttestation>();
}

export async function postHealthPlanNotesAttestationForReferral({
    npi,
    referralId,
    payerId,
}: {
    npi: string;
    referralId: string;
    payerId: string;
}) {
    const url = `${CLIENT_API_URL}/${payerId}/attestations`;
    const body = { referral_id: referralId };
    return fmhNpiAPI({ url, npi }).post(body).json();
}

/* First refusal claim automation rules */

export async function getFirstRefusalClaims({
    npi,
    payerId,
    segmentId,
}: {
    npi: string;
    payerId: string;
    segmentId: string;
}) {
    const url = `${CLIENT_API_URL}/${payerId}/${segmentId}/first_refusal_claims`;
    return fmhNpiAPI({ url, npi }).get().json<
        {
            first_refusal_claim_id: string;
            segment_id: string;
            claim_timestamp: string;
            description: string;
            member_id: string;
            dateofbirth: string;
            firstname: string;
            product_service_oid: string;
            is_active: boolean;
            run_once: boolean;
            active_through?: string;
        }[]
    >();
}

export async function postFirstRefusalClaim({
    npi,
    payerId,
    segmentId,
    description,
    memberId,
    memberDOB,
    memberFirstName,
    productServiceOid,
}: {
    npi: string;
    payerId?: string;
    segmentId?: string;
    description: string;
    memberId?: string;
    memberDOB?: string;
    memberFirstName?: string;
    productServiceOid?: string;
}) {
    const url = `${CLIENT_API_URL}/${payerId}/${segmentId}/first_refusal_claims`;
    return fmhNpiAPI({ url, npi })
        .post({
            description,
            member_id: memberId,
            dateofbirth: memberDOB,
            firstname: memberFirstName,
            product_service_oid: productServiceOid,
            is_active: true,
            run_once: true,
        })
        .json<{ claim_id: string }>();
}

export async function putFirstRefusalClaim({
    npi,
    id,
    payerId,
    segmentId,
    description,
    memberId,
    memberDOB,
    memberFirstName,
    productServiceOid,
    isActive,
}: {
    npi: string;
    id: string;
    payerId?: string;
    segmentId?: string;
    description?: string;
    memberId?: string;
    memberDOB?: string;
    memberFirstName?: string;
    productServiceOid?: string;
    isActive?: boolean;
}) {
    const url = `${CLIENT_API_URL}/${payerId}/${segmentId}/first_refusal_claims/${id}`;
    return fmhNpiAPI({ url, npi })
        .put({
            description,
            member_id: memberId,
            date_of_birth: memberDOB,
            firstname: memberFirstName,
            product_service_oid: productServiceOid,
            is_active: isActive,
        })
        .json();
}

export async function deleteFirstRefusalClaim({
    npi,
    id,
    payerId,
    segmentId,
}: {
    npi: string;
    id: string;
    payerId: string;
    segmentId: string;
}) {
    const url = `${CLIENT_API_URL}/${payerId}/${segmentId}/first_refusal_claims/${id}`;
    return fmhNpiAPI({ url, npi }).delete().json();
}
